import { render, staticRenderFns } from "./ConversationBox.vue?vue&type=template&id=f5ae1242&scoped=true"
import script from "./ConversationBox.vue?vue&type=script&lang=js"
export * from "./ConversationBox.vue?vue&type=script&lang=js"
import style0 from "./ConversationBox.vue?vue&type=style&index=0&id=f5ae1242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ae1242",
  null
  
)

export default component.exports